module.exports = __webpack_public_path__ + "img/register-Icon.459d8c62.png";